export default __webpack_public_path__ + "static/media/ackert-logo.5f1d9422.svg";